import Accordion from '../components/Accordion';
import AjaxPanels from '../components/AjaxPanels';
import Panels from '../components/Panels';
import InclusionDetailsLoad from '../components/InclusionDetailsLoad';
import { initSpecificPhotoSlideShows } from '../components/SpecificPhotoSlideshow';
import StickyNav from '../components/StickyNav';
import { initMap } from '../components/CommunityMap';
import LightBox from '../components/LightBox';
import GalleryPlanPhotoSlideshow from '../components/GalleryPlanPhotoSlideshow';
import Modal from '../components/Modal';
import FloorplanZoom from '../components/FloorplanZoom';
import GalleryVideoPlayers from '../components/GalleryVideoPlayers';
import {
  destroyDiscoverMobileLeadInCarousel,
  initDiscoverMobileLeadInCarousel,
} from '../components/DiscoverLeadInCarousel';

document.addEventListener('DOMContentLoaded', () => {
  initDiscoverMobileLeadInCarousel();
  //sticky nav init
  const stickyNav = StickyNav();
  stickyNav.init();

  const inclusionsLoad = InclusionDetailsLoad(true, () => {
    stickyNav.refresh();
  });
  AjaxPanels(
    'js-hfs-inclusion-panels',
    'js-hfs-inclusion-panel-content',
    () => {
      inclusionsLoad.reinitialize();
      Panels('js-bath-panels', () => {
        stickyNav.refresh();
      });
      stickyNav.refresh();
    },
  );
  initSpecificPhotoSlideShows();
  Accordion('js-fp-details-accordion');
  LightBox();
  Panels('js-community-features-panels');

  GalleryPlanPhotoSlideshow();
  GalleryVideoPlayers.initPlayers();
  //   PromoVideoPlayer.initPlayers();
  Panels('js-plan-gallery-panels', () => GalleryVideoPlayers.stopPlaying());
  highlightLotOnPlatMap();
  //download modal
  const downloadModal = Modal('js-download-modal');
  const downloadModalBtns = document.querySelectorAll('.js-btn-downloads');
  downloadModalBtns.forEach(downloadModalBtn => {
    downloadModalBtn.addEventListener('click', event => {
      event.preventDefault();
      downloadModal.open();
    });
  });

  FloorplanZoom();

  const shareModal = Modal('js-share-modal');
  if (shareModal) {
    const shareModalBtns = document.querySelectorAll('.js-btn-share');
    shareModalBtns.forEach(shareModalBtn => {
      shareModalBtn.addEventListener('click', event => {
        event.preventDefault();
        shareModal.open();
      });
    });

    document.querySelector('.js-btn-copy')?.addEventListener('click', event => {
      const copyBtn = event.currentTarget as HTMLButtonElement;

      const inputElement = document.getElementById(
        'txt-copy-listing',
      ) as HTMLInputElement;

      if (inputElement) {
        // Copy the value of the input field to the clipboard
        navigator.clipboard
          .writeText(inputElement.value)
          .then(() => {
            copyBtn.textContent = 'Copied to Clipboard!';
          })
          .catch(err => {
            console.error('Failed to copy: ', err);
          });
      }
    });
  }
});

function highlightLotOnPlatMap() {
  const platMapContainer = document.getElementById('js-plat-map-container');

  if (platMapContainer) {
    const _circId = platMapContainer.dataset.circId;
    const activeLot = document.getElementById(`hs-${_circId}`);

    if (activeLot) {
      activeLot.style.display = 'block';
    }
  }
}

function handleResize(): void {
  destroyDiscoverMobileLeadInCarousel();
  initDiscoverMobileLeadInCarousel();
}

window.addEventListener('resize', handleResize, { passive: true });

window.addEventListener('load', () => {
  //initialize map
  initMap().catch(error => {
    console.error('Failed to initialize map:', error);
  });
});
